import React from 'react'
import Content, { HTMLContent } from '../components/Content'
import { Box } from 'rebass'
import styled from 'styled-components'
import Footer from '../components/Footer'
import Newsletter from '../components/Newsletter'
import Donation from '../components/Donation'

const Wrapper = styled.div`
  // width: 50rem;
  // max-width: 48rem;
`

export const PageTemplate = ({
  title,
  content,
  contentComponent,
  footer,
  location,
}) => {
  const PageContent = contentComponent || Content

  return (
    <div>
      <Box
        m={[3, 4]}
        p={[4, 5]}
        bg="white"
        style={{ boxShadow: '0 0 1.5rem rgba(0,0,0,0.25)' }}
      >
        <Wrapper>
          <PageContent
            className="content"
            content={content}
            location={location}
            style={{ width: '100%' }}
          />
          {/*  location.includes('donate-to-travel-assistance') && <Donation />  */}
        </Wrapper>
      </Box>
      <Box
        m={[3, 4]}
        p={[4, 5]}
        bg="white"
        style={{ boxShadow: '0 0 1.5rem rgba(0,0,0,0.25)' }}
      >
        <Footer content={footer} />
        <Newsletter />
      </Box>
    </div>
  )
}

const Page = ({ data, location, language }) => {
  const { wordpressPage: post, footer } = data

  console.log(footer)

  return (
    <PageTemplate
      contentComponent={HTMLContent}
      title={post.slug}
      content={language === 'french' ? post.acf.french_content : post.content}
      footer={
        language === 'french' ? footer.acf.french_content : footer.content
      }
      location={location.pathname}
    />
  )
}

export default Page

export const pageQuery = graphql`
  query WordpressPage($id: String!) {
    wordpressPage(id: { eq: $id }) {
      content
      slug
      acf {
        french_content
      }
    }
    footer: wordpressPage(id: { eq: "63413bc4-6b1e-586c-8afc-833e80f7f3dd" }) {
      id
      content
      acf {
        french_content
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/wordpress.js